import { render, staticRenderFns } from "./ThePagination.vue?vue&type=template&id=0d0df8a7&scoped=true&"
import script from "./ThePagination.vue?vue&type=script&lang=js&"
export * from "./ThePagination.vue?vue&type=script&lang=js&"
import style0 from "./ThePagination.vue?vue&type=style&index=0&id=0d0df8a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0df8a7",
  null
  
)

export default component.exports